import ReceiptIcon from '@material-ui/icons/Receipt';

import List from './List';
import show from './Show';
import Create from './Create';

export default {
    list: List,
    show: show,
    create: Create,
    icon: ReceiptIcon,
};
